import {NgModule} from '@angular/core';
import {TranslateModule, SliderSwitchModule} from '@xref/ngx';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {SettingsMenuComponent} from './settings-menu.component';
import {FormsModule} from '@angular/forms';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    SliderSwitchModule,
    FontAwesomeModule,
    FooterModule
  ],
  exports: [SettingsMenuComponent],
  declarations: [SettingsMenuComponent]
})
export class SettingsMenuModule {}
